import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '@environment';
import { AuthService } from '@app/services/auth.service';
import { recentApi } from '@recent-searches/recent.api';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';

@Injectable()
export class RecentService {
  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService
  ) { }

  public fetchRecentSearches(): Observable<RecentSearchModel[]> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.get<RecentSearchModel[]>(recentApi.home_searches_recent, { headers });
  }

  public deleteRecentSearches(): Observable<RecentSearchModel[]> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.delete<RecentSearchModel[]>(recentApi.home_searches_recent_delete, { headers });
  }

  public saveFlightSearch(payload: RecentSearchModel): Observable<RecentSearchModel> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.post<RecentSearchModel>(recentApi.air_save_searches, { ...payload }, { headers });
  }

  public saveBusSearch(payload: RecentSearchModel): Observable<RecentSearchModel> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.post<RecentSearchModel>(recentApi.bus_save_searches, { ...payload }, { headers });
  }

  public saveHotelSearch(payload: RecentSearchModel): Observable<RecentSearchModel> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.post<RecentSearchModel>(recentApi.hotel_save_searches, { ...payload }, { headers });
  }

  public saveCarsSearch(payload: RecentSearchModel): Observable<RecentSearchModel> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.post<RecentSearchModel>(recentApi.auto_save_searches, { ...payload }, { headers });
  }

  public saveAirPackageSearch(payload: RecentSearchModel): Observable<RecentSearchModel> {
    const headers = this.getHeaders(ENV.x_application_id);
    return this.http.post<RecentSearchModel>(recentApi.air_packages_save_searches, { ...payload }, { headers });
  }
  
  private getHeaders(applicationID: string = null): HttpHeaders {
    const params = {};
    if (applicationID) {
      params['X_Application_ID'] = applicationID;
    }
    return new HttpHeaders(params);
  }
}
